export const MAX_INT_VALUE = 2147483647;
export const DEFAULT_MINIMUM_FETCHED_OPTIONS = 4;
export const DEFAULT_MEDIUM_FETCHED_OPTIONS = 15;
export const DEFAULT_FETCHED_OPTIONS = 32;
export const DEFAULT_DEBOUNCE_TIMEOUT = 300;